module.exports = __webpack_public_path__ + "assets/c278e55652d3360bc59c948f326355cc.svg";